export const BASIC_STREAMING_PACKAGE = "free";
export const PRO_STREAMING_PACKAGE = "premium";
export const STREAM_ORIENTATION = "auto";

// Pro Mode is unlocked only after checkout succeeds. New event records always
// start in Basic Mode so a cancelled or failed payment cannot unlock Pro Mode.
export const getInitialStreamingPackage = () => BASIC_STREAMING_PACKAGE;

export const requiresProModeCheckout = (selectedPackage) =>
  selectedPackage === PRO_STREAMING_PACKAGE;

// Camera shape is selected by the browser/device. The actual decoded track and
// each viewer's viewport decide presentation without reacquiring the camera.
export const normalizeEventOrientation = () => STREAM_ORIENTATION;

export const canStartEventCreation = ({ currentStep, explicitFinalAction, promoValidating }) =>
  currentStep === 5 && explicitFinalAction === true && promoValidating !== true;

export const buildProModeCheckoutPayload = ({ eventId, originUrl, promoCode }) => ({
  event_id: eventId,
  origin_url: originUrl,
  promo_code: promoCode?.trim() || null,
});

export const isProModeUnlocked = (event) =>
  event?.streaming_package === PRO_STREAMING_PACKAGE;
